import { createAction } from 'redux-actions';
export const ADD_FLIGHT_IDS = 'ADD_FLIGHT_ID_IDS';
export const REMOVE_FLIGHT_IDS = 'REMOVE_FLIGHT_IDS';
export const CHANGE_FLIGHT_ID = 'CHANGE_FLIGHT_ID';
export const addFlightIds = createAction(ADD_FLIGHT_IDS);
export const removeFlightIds = createAction(REMOVE_FLIGHT_IDS);
export const changeFlightId = createAction(CHANGE_FLIGHT_ID);
